export default "__VITE_ASSET__D7vik9WL__"